import { render, staticRenderFns } from "./BomFormats.vue?vue&type=template&id=03088a4a&"
import script from "./BomFormats.vue?vue&type=script&lang=js&"
export * from "./BomFormats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports